import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'

import legUtil from '../util/leg.util'


import TeamBlock from '../team/teamblock.container'
import {INIT_STATE} from '../init/initialdata.action'
import {TripLength} from '../init/triplength.component'
import {AddDestination} from '../init/destination/add_destination.component'
import ViewDestinationContainer from '../init/destination/viewdestination.container'
import DetailsContainer from '../details/details.container'

import {DETAIL_SECTION, DETAIL_SUB_SECTION} from '../details/details.component'


export class ItineraryBottom extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            showDestination: false,
            activeDestination: null,
            availableDetailSections: DETAIL_SECTION,
            availableDetailSubSections: DETAIL_SUB_SECTION,
        }

        _.bindAll(this,
            'getContent',
            'onShowDestination',
            'onHideDestination',
            'showDetails',
            'onSetDestination'
        )
    }

    componentWillReceiveProps(nextProps, nextState) {
        // maybe we should just reset the state?
        this.setState({showDestination: false, activeDestination: null})
        // might want to change this to actually get the destination out of the nextProps
    }

    onShowDestination(destination) {
        this.setState({showDestination: true, activeDestination: destination.toObject()})
    }

    onHideDestination() {
        this.setState({showDestination: false, activeDestination: null})
    }

    onSetDestination() {
        let newStart = Math.ceil(this.props.lastLeg.getIn(['properties', 'end'])) // our new start date, after the last item
        let newLength = 1 // default to one day long

        // console.log("what type of object is the destination?")
        // console.log(this.state.activeDestination)

        // returns JSON Object
        let newDestination = legUtil.formatDestination(this.state.activeDestination)

        // Is our newStart + length within our itinerary? If not, add a day, if so, add the leg
        if (newStart + 1 > this.props.totalDays) {
            // console.log('Need another day')
            this.props.onAppendDay(newStart, newDestination)
        } else {
            // console.log('all set!')
            this.props.onAddLegAndDestination(newStart, newDestination)
        }
    }

    showDetails(destination) {
        this.setState({showDestination: true, activeDestination: destination})
    }

    getContent() {
        switch (this.props.initStep) {
            case INIT_STATE.SET_TRIP_LENGTH:
                return <TripLength
                    onSaveTripLength={this.props.onSaveTripLength}
                    progressInitState={this.props.onProgressInitState}/>
            case INIT_STATE.ADD_DESTINATION:
                return <AddDestination
                    leg={this.props.activeLeg}
                    lastLeg={this.props.lastLeg}
                    totalDays={this.props.totalDays}
                    regressInitState={this.props.onRegressInitState}
                    progressInitState={this.props.onProgressInitState}
                    onSelectDestination={this.props.onSelectDestination}
                    availableDetailSections={this.state.availableDetailSections}
                    availableDetailSubSections={this.state.availableDetailSubSections}/>
            default:
                if (this.state.showDestination) {
                    return <ViewDestinationContainer
                        showDetails={this.showDetails}
                        activeDestination={this.state.activeDestination}
                        onShowSearch={this.onHideDestination}
                        onSetDestination={this.onSetDestination}
                        availableDetailSections={this.state.availableDetailSections}
                        availableDetailSubSections={this.state.availableDetailSubSections}/>
                } else {
                    return <DetailsContainer
                        {...this.props}
                        onShowDestination={this.onShowDestination}
                        showDetails={this.showDetails}/>
                }
        }
    }

    render() {
        let content = this.getContent()
        let halfHiddenClass = classNames({
            'collapsed': this.props.halfHidden
        })

        let teamBlock = <TeamBlock/>
        if (window._isMobile) {
            teamBlock = null
        }

        let shareFacebook = function () {
            if (window.FB) {
                window.FB.ui({
                    method: 'share',
                    href: window.location.href
                })
            }
        }

        let pinIt = function () {
            if (window.PinUtils) {
                window.PinUtils.pinAny()
            }
        }

        let mailto = `mailto:?subject=${encodeURI(window.document.title)}&body=Check out this itinerary on lunamoons.com - ${encodeURI(window.location.href)}%0D%0A%0D%0AWant more travel inspiration from Luna? Sign up here: ${encodeURI('https://www.lunamoons.com/#join')}`

        return (
            <div>
                <div id="itinerary-lower" className={halfHiddenClass}>
                    {content}
                    {teamBlock}
                    {this.props.lunaTripSlug &&
                    (<div className="planner-social-icons text-center">
                        <span className="title">Share</span>
                        <a id="fa-share-button" className="fa-stack clickable" onClick={shareFacebook}>
                            <i className="fas fa-circle fa-stack-2x social-icon-background"/>
                            <i className="fab fa-facebook-f fa-stack-1x text-white"/>
                        </a>
                        <a href={mailto}
                           className="fa-stack">
                            <i className="fas fa-circle fa-stack-2x social-icon-background"/>
                            <i className="far fa-envelope fa-stack-1x text-white"/>
                        </a>
                        <a onClick={pinIt} className="fa-stack clickable">
                            <i className="fas fa-circle fa-stack-2x social-icon-background"/>
                            <i className="fab fa-pinterest-p fa-stack-1x text-white"/>
                        </a>
                    </div>)
                    }
                </div>
                <div className="copyright-notices">
                    <span>†All or part of text sourced from <a href="https://en.wikivoyage.org/" target="_blank">Wikivoyage</a> or <a href="https://en.wikipedia.org" target="_blank">Wikipedia</a> and is available under the <a href="https://en.wikipedia.org/wiki/Wikipedia:Text_of_Creative_Commons_Attribution-ShareAlike_3.0_Unported_License" target="_blank">Creative Commons Attribution-ShareAlike License</a>.</span><br/>
                    <span>Images may be subject to copyright. Click on image for attribution details.</span>
                </div>
            </div>
        )
    }
}
